import React from 'react';
import PropTypes from 'prop-types';

const UserAccount = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 21 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.1896 19.0311C15.8477 17.9679 15.0945 17.0285 14.0466 16.3584C12.9987 15.6884 11.7148 15.3252 10.394 15.3252C9.07324 15.3252 7.78934 15.6884 6.74148 16.3584C5.69361 17.0285 4.94034 17.9679 4.59849 19.0311"
      stroke={color}
      strokeWidth="2"
    />
    <circle cx="10.394" cy="8.3252" r="3" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <rect x="1.39404" y="1.3252" width="18" height="18" rx="3" stroke={color} strokeWidth="2" />
  </svg>
);

UserAccount.propTypes = {
  color: PropTypes.string.isRequired,
};

export default UserAccount;
